import styled from 'styled-components';

export const Form = styled.form`
    background-color: #fff;
    padding: 20px;
    max-width: 500px;
    margin: 0 auto;
`;

export const Submit = styled.div`
    text-align: right;
`;

export const Text = styled.p`
    font-size: .9em;
    color: #666;
`;